import { useState } from 'react'
import { toast } from 'react-toastify'

import { axiosInstance } from '../helpers'
import { ModelMap, UnitInspection } from '../models'

export const useUnitInspections = () => {
    const [unitInspections, setUnitInspections] = useState<
        SimpleUnitInspection[]
    >([])

    const [unitInspectionUnitMap, setUnitInspectionUnitMap] = useState<
        ModelMap<SimpleUnitInspection>
    >({})

    const [
        unitInspectionDetail,
        setUnitInspectionDetail,
    ] = useState<UnitInspection | null>(null)

    const [
        loadingUnitInspectionDetail,
        setLoadingUnitInspectionDetail,
    ] = useState(false)

    const getUnitInspections = async (inspectionId: number) => {
        try {
            const response = await axiosInstance.get(
                `inspection/unit-inspection/get_schedule_unit_inspections/`,
                {
                    params: {
                        inspection_id: inspectionId,
                    },
                },
            )
            const data = response.data as SimpleUnitInspection[]
            setUnitInspections(data)
            // Convert list to map using unit_id as the key
            const unitInspectionMapData = data.reduce((prev, item) => {
                // Only add to map if unit_id exists and is a valid number
                if (
                    item.unit_id !== undefined &&
                    item.unit_id !== null &&
                    !isNaN(item.unit_id)
                ) {
                    return {
                        ...prev,
                        [item.unit_id]: item,
                    }
                }
                return prev
            }, {} as ModelMap<SimpleUnitInspection>)
            setUnitInspectionUnitMap(unitInspectionMapData)
            return Promise.resolve(data)
        } catch (error) {
            toast.error('Failed to get unit inspections')
            return Promise.reject(error)
        }
    }

    const getUnitInspectionDetail = async (unitInspectionId: number) => {
        try {
            setLoadingUnitInspectionDetail(true)
            const response = await axiosInstance.get(
                `inspection/unit-inspection/${unitInspectionId}/`,
            )
            const data = response.data as UnitInspection
            setUnitInspectionDetail(data)
            setLoadingUnitInspectionDetail(false)
            return Promise.resolve(data)
        } catch (error) {
            setLoadingUnitInspectionDetail(false)
            toast.error('Failed to get unit inspection detail')
            return Promise.reject(error)
        }
    }

    return {
        unitInspections,
        unitInspectionUnitMap,
        unitInspectionDetail,
        loadingUnitInspectionDetail,
        setUnitInspectionDetail,
        getUnitInspections,
        getUnitInspectionDetail,
    }
}

export interface SimpleUnitInspection {
    id: number
    complete_status: boolean
    unit_id: number
}
